import React, { useState, useEffect, useCallback } from 'react';
import InternalNav from '../common/InternalNav';
import { __ } from '../../Lang.js';

const HeroSection = ({ featuredVideos = [], isLoggedIn }) => {
  const videos = Array.isArray(featuredVideos)
    ? featuredVideos
    : featuredVideos
    ? [featuredVideos]
    : [];
  if (videos.length === 0) return null;

  const [isMobile, setIsMobile] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const goToNext = useCallback(() => {
    setActiveIndex((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
  }, [videos.length]);

  useEffect(() => {
    const interval = setInterval(goToNext, 10000);
    return () => clearInterval(interval);
  }, [goToNext]);

  const currentVideo = videos[activeIndex];
  const videoUrl = `/app/twi/watch?v=${currentVideo.uniqid}`;
  const thumbnailUrl = currentVideo.preview_image_url || currentVideo.image_poster || currentVideo.image_thumbnail;
  const videoTitle = currentVideo.name || 'Featured Video';

  return (
    <section className={`hero ${isMobile ? 'hero--mobile' : ''}`}>
<a href="/app/twi" className="hero__back-hotspot" aria-label="Back to Home" />
<div className="hero__background">
  <div className="hero__logo-bg"></div>
  <video autoPlay muted loop playsInline>
    <source src="https://now.cdn.msia.org/3259/TWI/twi_hero.mp4" type="video/mp4"/>
  </video>
</div>

      <div className="hero__overlay" />
      
      <div className="hero__content">
        {/* Desktop layout - ALWAYS rendered, unchanged */}
        <div className="hero__text">

          <h1>
            { __('Explore the Path of Soul Transcendence') }</h1>
        </div>
        
        <div className="hero__sidebar">
          <InternalNav isLoggedIn={isLoggedIn} />
          <a href={videoUrl} className="hero__featured-video">
            <span className="featured-hero-badge">{ __('FEATURED') }</span>
            <span className="featured-hero-title">{videoTitle}</span>
            <div style={{ backgroundImage: `url(${thumbnailUrl})` }} />
          </a>
        </div>

        {/* Mobile layout - ADDITIONAL elements for mobile only */}
        {isMobile && (
          <>
            {/* Navigation at TOP */}
            <div className="hero__mobile-nav">
              <InternalNav isLoggedIn={isLoggedIn} />
            </div>

            {/* Featured video in MIDDLE */}
            <div className="hero__mobile-featured">
              <a href={videoUrl} className="hero__featured-video--mobile">
                <span className="featured-hero-badge">{ __('FEATURED') }</span>
                <span className="featured-hero-title">{videoTitle}</span>
                <div style={{ backgroundImage: `url(${thumbnailUrl})` }} />
              </a>
            </div>

            {/* Hero title at BOTTOM */}
            <div className="hero__mobile-text">
              <h1>{ __('Explore the Path of Soul Transcendence') }</h1>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default HeroSection;